import styled from '@emotion/styled';
import { Slider, Switch } from 'antd';
import { colorConstants } from 'config/colorConstants';
import { UserContext } from 'contexts/ConfigContext';
import React, { FC, useContext, useState } from 'react';
import { calculateFontSize, getConfig } from 'utils/helperMethods';

export const sliderWidth = calculateFontSize(window.innerWidth, 130);
export const CustomSlider = styled(Slider)`
    .ant-slider-handle {
        border: 2.5px solid ${colorConstants.violet};
    }
    .ant-slider-track {
        background-color: ${colorConstants.violet};
    }
    .ant-slider-dot-active {
        border-color: ${colorConstants.violet};
    }
    :hover .ant-slider-track {
        background-color: ${colorConstants.violet};
    }
    :hover .ant-slider-handle:not(.ant-tooltip-open) {
        border-color: ${colorConstants.violet};
    }
`;
interface props {
    minMaxValue: any;
    setMinMaxValue: Function;
    defaultValue: [number, number];
    min: number;
    max: number;
    disabled?: boolean;
}
const RangeSlider: FC<props> = ({ minMaxValue, setMinMaxValue, defaultValue, min, max, disabled }) => {
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);
    const onChange = (value: number | [number, number]) => {
        setMinMaxValue(value);
    };
    // const onAfterChange = (value: number | [number, number]) => {
    //     setMinMaxValue(value);
    // };

    return (
        <>
            <CustomSlider
                disabled={disabled}
                range
                value={minMaxValue}
                style={{ width: sliderWidth }}
                defaultValue={defaultValue}
                step={1}
                min={min}
                max={max}
                onChange={onChange}
                //  onAfterChange={onAfterChange}
            />
        </>
    );
};

export default RangeSlider;
